var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine1Custom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 1,
    viewBox: "0 0 505 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 505,
    y2: 0.5,
    stroke: "#233C73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine1Custom);
export default __webpack_public_path__ + "static/media/line1-custom.ed1fd783a09094ffd2ec68120826472e.svg";
export { ForwardRef as ReactComponent };